(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, View, Config, Helper, Service, Handler, Model, Message, Validation, Analytics, FacebookInstantArticles, $, LocalStorage) {
    'use strict';

    /* METODOS PRIVADOS */

    let ComboController = function (modo) {
        /* Este controller reemplaza a Controller.comboBonificado y Controller.comboPago
         * como hay un unico route que tiene modo V, entonces elimino la condicion de source
         * No se cambia la funcionalidad solo refactory
         */
        if ((modo === 'V' || modo === 'E') || Model.Window.lastFlow === "B") {
            if (Model.Cliente.comboElegido == Config.COMBO_BONIFICADO) {
                Controller.flowF();
            }
            else {
                Controller.flowC();
            }
        }
        else {
            Controller.flowB({
                combo: Model.Cliente.comboElegido
            });
        }
    };

    const IosRedirect = function () {
        //alert(Model.Window.isSafari);
        //alert(Config.WondersoftRedirectEnabled);
        //alert(Config.urlWondersoftRedirect);

        if (Model.Window.isSafari && Config.WondersoftRedirectEnabled && Model.Cliente.comboElegido != Config.COMBO_BONIFICADO) {
            if (!document.cookie.match(/^(.*;)?\s*fixed\s*=\s*[^;]+(.*)?$/)) {
                // Set cookie to maximum (https://stackoverflow.com/a/33106316/1502448)
                document.cookie = 'fixed=fixed; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/';
                window.location.replace(Config.urlWondersoftRedirect);
            }
        }
    }

    /* METODOS PUBLICOS */

    Controller.inicio = function (combo) {
        console.log('Iniciocontroller:' + combo);
        // Si no esta logueado redirecciona al combo que corresponde
        //var source = ((!Helper.isEmpty(source)) ? source : null);
        if (Helper.isEmpty(Model.Me)) {
            Service.isLogged(function () {
                Controller.inicio(combo);
            }, function () {
                Helper.redirectToLoginWCombo(combo);
                return false;
            });
            return false;
        }
        
        Model.Cliente.comboElegido = combo;
        Service.wallConfig()
            .then(function () {
                Model.setCombo(combo)
                IosRedirect();
                Model.InitializeNewsletter(combo)
                ComboController(Model.Window.modo)
            })
    }


    Controller.ingresarDni = function () {
        if (!Validation.validateOnSubmit('datos_personales')) return false;
        Model.getInputsBy('datos_personales').save(Model.Cliente);
        Controller.flowD(Model.Cliente);
    }

    Controller.ingresarDni_OtroUsuario = function () {
        Helper.Ingreso_dni_MostrarMailOfuscado();
        LN.Wcentrix && LN.Wcentrix.initChat();
        Helper.hidePreloader();
    }

    Controller.formularioDatosPersonales = function () {
        if (!Validation.validateOnSubmit('datos_personales')) return false;
        Model.getInputsBy('datos_personales').save(Model.Cliente);
        Controller.iniciarVenta(null, Model.Cliente, function (res, status, xhr) {
            Handler.iniciarVenta(res, status, xhr);
        });




        // Una vez que guarda el cliente redirecciona a formularios de envio
        //Service.clienteGuardar(Model.Cliente, function (res, status, xhr) {
        //    Handler.clienteGuardar(res, status, xhr);
        //})
    }

    Controller.iniciarVenta = function (domicilio, cliente, cb) {
        var model = {
            SitioOrigen: Config.SitioOrigen,
            planId: Model.PlanElegido.id,
            campaniaId: Model.Campania.id,
            idCanalDeVenta: Model.canalDeVenta,
            idFormaDeContacto: Model.Window.contact
        };
        if (cliente) model.clienteModel = cliente;
        if (!domicilio) {
            model.domicilioModel = { domicilioExtranjero: Model.Cliente.residencia };
        } else {
            model.addressId = domicilio.id;
        }
        Service.iniciarVenta(model, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        });
    }

  
    Controller.formularioDatosPersonalesClienteNuevo = function () {
        Model.Cliente.NuevoCliente = "true";
        Model.Cliente.email = LN.Model.Me.Usuario.usuarioemail;
        LN.AppEvent.sendEvent('DNI_OK');
        View.formularioDatosPersonales();
    }

    Controller.obtenerMontoACobrar = function (cb) {

        Service.obtenerMontoACobrar({
            idPlanVta: Model.PlanElegido.id,
            idCampania: Model.Campania.id
        }, function (r) {
            Handler.obtenerMontoACobrar(r);
            cb && cb();
        });
    }

    Controller.posdatarDomicilio = function () {
        Helper.hideCustomMessageError('error-domicilio');
        Helper.disableNextButton();

        var isAddressFormEmpty = (Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "calle").get().value)) && (Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "altura").get().value)) && (Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "cp").get().value)) && (Helper.isEmpty(LN.Model.getInputsBy("datos_envio", "localidad").get().value));

        if (isAddressFormEmpty) {

            // Si el formulario está vacío, se dirige a pantalla de gracias.
            View.confirmacionCombo2();

        } else {

            // Verifica si está OK el formulario.
            var isAddressOk = (!Helper.isEmpty(Model.getInputsBy("datos_envio", 'id').get().value)) || Validation.validateOnSubmit('datos_envio', { 'normalizar_domicilio': 'normalizar_domicilio' });

            if (isAddressOk) {

                Helper.showPreloader();

                var datarequest = {
                    "IdCanalVenta": Config.canalesDeVenta[Model.Window.modo] || Config.canalesDeVenta['S'],
                    "PlanId": Model.PlanElegido.id,
                    "EditarDomicilio": {
                        "addressId": Model.Venta.Domicilio.id,
                        "altura": Model.getInputsBy("datos_envio", 'altura').get().value,
                        "calle": Model.getInputsBy("datos_envio", 'calle').get().value,
                        "cp": Model.getInputsBy("datos_envio", 'cp').get().value,
                        "dpto": Model.getInputsBy("datos_envio", 'depto').get().value,
                        "entreCalle1": Model.getInputsBy("datos_envio", 'entreCalle1').get().value,
                        "entreCalle2": Model.getInputsBy("datos_envio", 'entreCalle2').get().value,
                        "localidad": Model.getInputsBy("datos_envio", 'localidad').get().value,
                        "pais": "ARGENTINA",
                        "piso": Model.getInputsBy("datos_envio", 'piso').get().value,
                        "provincia": Model.getInputsBy("datos_envio", 'provincia').get().value,
                        "torre": Model.getInputsBy("datos_envio", 'torre').get().value,
                        "cuerpo": Model.getInputsBy("datos_envio", 'cuerpo').get().value,
                        "lote": Model.getInputsBy("datos_envio", 'lote').get().value
                    }
                };

                // Si está bien, se realiza posdatar domicilio.
                Service.posdatarDomicilio(datarequest, function (data) {
                    console.log(data);
                    Helper.hidePreloader();
                    Handler.posdatarDomicilio(data);
                });

            } else {

                Helper.enableNextButton();

            }
        }
    }


    Controller.validarPago = function (pago) {
        console.log('validacion de pago');
        // Limpio mensaje de error
        $('#mensaje').html('');
        switch (pago.CODRTA) {
            case '1173-00':
            case '1174-00':

              


                // Solicitud OK
                var data = {
                    SitioOrigen: Config.SitioOrigen,
                    Codrta: pago.CODRTA,
                    Descripcion: pago.DESCRIPCION,
                    hash: pago.HASH,
                    password: pago.PASSWORD,
                    mascara: pago.MASCARA,
                    token: pago.TOKEN,
                    token_da: pago.TOKEN_DA,
                    esExtranjero: Model.Venta.esExtranjero,
                    planId: Model.PlanElegido.id,
                    campaniaId: Model.Campania.id,
                    importeEtapas: {
                        cantidadMesesPrimeraEtapa: Model.PlanElegido.mesesDescuento,
                        importePrimeraEtapa: Model.PlanElegido.precio,
                        importeSegundaEtapa: Model.PlanElegido.precioSinDescuento
                    }
                };

                Service.procesarPago(data, Handler.procesarPago);
                break;
            case '1174-04':
            case '1174-10':
                // Error en carga
                View.formularioPago(Message.Pago.ERROR_CARGA, true);
                break;
            case '1173-07':
            case '1174-08':
                // Solicitud vencida
                Controller.iniciarVenta(Model.Venta.Domicilio, null, function (res, status, xhr) {
                    if (res.code == '0000') {
                        Model.setPago(res.response.formularioWondersoft);
                        View.formularioPago(Message.Pago.SOLICITUD_VENCIDA);
                    }
                });
                break;
            case '1174-18':
            case 'TA':
                // Error de datos
                Controller.iniciarVenta(Model.Venta.Domicilio, null, function (res, status, xhr) {
                    if (res.code == '0000') {
                        Model.setPago(res.response.formularioWondersoft);
                        View.formularioPago(Message.Pago.DATOS_INVALIDOS);
                    }
                });
                break;
            default:
                // Error generico
                Controller.iniciarVenta(Model.Venta.Domicilio, null, function (res, status, xhr) {
                    if (res.code == '0000') {
                        Model.setPago(res.response.formularioWondersoft);
                        View.formularioPago(Message.Pago.ERROR_GENERAL);
                    }
                });
                break;
        }
    }

    
    Controller.aceptaTyC = function () {
        var refreshError = true;
        Service.campanaObtener(Config.campaniaBonificada, function (res, status, xhr) {
            if (res.code == "0000") {
                Model.Campania.id = Config.campaniaBonificada;
                Model.PlanElegido = res.response.grupoPlanes[0];

                Service.iniciarVenta({
                    campaniaId: Model.Campania.id,
                    planId: Model.PlanElegido.id,
                    addressId: null,
                    tarjeta: null,
                    idCanalDeVenta: Model.canalDeVenta,
                    idFormaDeContacto: Model.Window.contact,
                    idOrigen: Model.idOrigen
                }, function (res, status, xhr) {
                    console.log(res.code);
                    if (res.code === "0000") {
                        const FacebookIA = new Promise(Controller.FbInstantArticlesVentaPromise);
                        const reshandler = () => {
                                    Model.Cliente.comboElegido = Config.COMBO_BONIFICADO;
                                    Handler.ventaBonificada(res, status, xhr);
                                    refreshError = false;
                        }
                         
                        Promise.all([FacebookIA])
                            .then(reshandler)
                            .catch(reshandler); 
    
                    } else Handler.aceptaTyCErrores(res.code);
                })
            } else Handler.aceptaTyCErrores(res.code);
        })

    }

    Controller.volver = function () {
        Helper.returnBack({
            url: document.referrer
        });
    }

    Controller.obtenerDatosPersonales = function () {
        Service.clienteObtenerDatosFiliatorios(function (data) {
            Handler.obtenerDatosFiliatorios(data);
        });
    }


    Controller.obtenerDatosPersonalesFormularioEnvio = function () {
        Service.clienteObtenerDatosFiliatorios(function (data, status, xhr) {
            Handler.obtenerDatosFiliatoriosFormularioEnvio(data, status, xhr);
        });
    }


    Controller.validarPinesProcesar = function () {

        if (!Validation.validateOnSubmit('validarpin')) return false;
        //View.validarPinGracias();
        $('#error').html('');

        Model.pin = Model.getInputsBy("validarpin", 'pin').get().value.trim();
        let dataValidar = {
            Pin: Model.pin
        };
        Service.validarPin(dataValidar, function (res) {
            Handler.validarPin(res);
        });
    }

    Controller.validarPinesTyC = function () {
        Analytics.clickValidarPin('Aceptar términos y condiciones');
        View.primerAcceso();
    }
    Controller.validarPinesMiClub = function () {
        Analytics.clickValidarPin('Desvincular');
        //window.open(Config.dominioMiCuenta + '/mi-club','_blank');
        location.href = Config.dominioMiCuenta + '/mi-club';
    }
    Controller.validarPinesReenviar = function () {
        //let dataReenviar = {};
        //Service.validarPinReenviar(dataReenviar, function (res) {
        //    Handler.validarPinReenviar();
        //});
        //View.validarPin(Message.Pines['PIN_VENCIDO']);
    }

    Controller.postVenta = function () {
        if (!Helper.isEmpty(Model.PlanElegido)) {
            Analytics.transaccionExitosa(Model.PlanElegido.nombre, Model.PlanElegido.precio, Model.Window.lastFlow);
        }
        // MOBILE: envio callback de venta OK.
        LN.AppEvent.sendEvent('VENTA-OK');

        LocalStorage.setItem('userLogedIn', true);
        localStorage.removeItem('userLogedIn'); 

        const onContinue = (arg) => {
           
            if (!Model.PlanElegido.planConCredencial) {
                // Si no requiere domicilio, muestra directamente la pantalla de gracias.
                Service.actualizarCookies(View.confirmacionCombo1());
            } else {
                if (!Model.Venta.esExtranjero && !Model.Venta.Background) {
                    // Si necesita domicilio muestra el formulario de envio.
                    Service.actualizarCookies(View.formularioEnvio());
                } else {
                    // Es extranjero, no necesita domicilio, abro pantalla de gracias.
                    Service.actualizarCookies(View.confirmacionCombo2());
                }
            }
        };

        const FacebookIA = new Promise(Controller.FbInstantArticlesVentaPromise);

        Promise.all([FacebookIA, Controller.guardarNewsletter()])
            .then(onContinue)
            .catch(onContinue);          
    }

    Controller.guardarNewsletter = function () {
        return new Promise((resolve, reject) => {
            if (Model.Newsletter && Model.Newsletter.length > 0) {
                Service.obtenerNewsletter()
                    .then((res) => {
                        Handler.obtenerNewsletter(res,resolve);
                    })
                    .catch((err) => resolve());
            }
            else {
                resolve();
            }
        });
    }

    Controller.postVentaBonificada = function () {
        const resetVarnish = new Promise((resolve, reject) => {
            Helper.resetImg('varnishReset', 'http://www.lanacion.com.ar/apw/api/v1/reset.gif', () => {
                console.log('resolve varnishReset');
                resolve()
            })
        });
        const resetFB = new Promise((resolve, reject) => {
            if (Model.IsInstantArticles()) {
                Helper.resetImg('externalPaywallToken', Model.ExternalPaywall.AutorizationToken, () => {
                    console.log('resolve externalPaywallToken');
                    resolve()
                })
            }
            else {
                resolve();
            }
        });

        const onContinue = () => {
            if (Model.IsInstantArticles()) {
                View.confirmacionBonificadoFacebook();
            }
            else {
                LN.AppEvent.sendEvent('VENTA-OK');
                LocalStorage.setItem('userLogedIn', true);
                localStorage.removeItem('userLogedIn'); 
                Helper.returnBack();
            }
        };

        Promise.all([resetVarnish, resetFB, Controller.guardarNewsletter()])
            .then(onContinue)
            .catch(onContinue); 
    }


    Controller.yaCompro = function () {
        const onContinue = () => {
            View.yaTieneCuentaFacebook();
        }
        if (Model.IsInstantArticles()) {
            const fbIA = new Promise(Controller.FbInstantArticlesYaTengoPromise);
            fbIA.then(onContinue).catch(onContinue);
        }
        else {
            View.yaCompro();
        }
    }


    Controller.yaTenia = function () {
        const onContinue = () => {
            View.yaTieneCuentaFacebook();
        }
        if (Model.IsInstantArticles()) {
            const fbIA = new Promise(Controller.FbInstantArticlesYaTengoPromise);
            fbIA.then(onContinue).catch(onContinue);
        } else {
            Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
            LN.AppEvent.sendEvent('YA-TENIA-PP');
            Helper.returnBack();
        }
    }

})(LN.Controller, LN.View, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Validation, LN.Analytics, LN.FacebookInstantArticles, jQuery, LN.LocalStorage);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/paywallController.js